import styled from 'styled-components';
import Action from 'components/Shared/Common/Action';
import { rgba } from 'polished';

export const Styled = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const StyledAction = styled(Action)`
    border-radius: 6px;
    margin-bottom: 5px;
    position: relative;
`;

export const StyledFileContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`;

export const StyledFileBase = styled.div`
    align-items: flex-start;
    background-color: ${({ theme }) => theme.white};
    border: 1px solid ${({ theme }) => rgba(theme.black, 0.1)};
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    position: relative;
    transition: all .25s ease;
    width: 100%;
    &:hover{
        .s-file-actions{
            opacity: 1;
            visibility: visible;
        }
    }
`;

export const StyledFileWrapper = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    flex-direction: row;
    padding: 10px;
    width: 100%;
`;

export const StyledFileActions = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 10px;
    transition: all .25s ease;
    visibility: hidden;
    white-space: nowrap;
    .btn{
        margin-right: 5px;
    }
`;

export const StyledFileIcon = styled.div`
    &.s-file-thumb{
        border: 1px solid ${({ theme }) => rgba(theme.black, 0.1)};
        border-radius: 6px;
        display: flex;
        flex-shrink: 0;
        height: 40px;
        margin-right: 10px;
        overflow: hidden;
        width: 40px;
        img{
            display: block;
            height: 100%;
            object-fit: cover;
            width: 100%;
        }
    }
    &.s-file-icon{
        align-items: center;
        display: flex;
        flex-shrink: 0;
        height: 44px;
        margin-right: 15px;
        width: 35px;
        img{
            max-width: 100%;
            width: 100%;
        }
    }
`;

export const StyledFileBaseContent = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .text,
    .subtext{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .text{
        color: ${({ theme }) => theme.black};
        display: block;
        font-size: 15px;
        font-weight: 700;
    }
    .subtext{
        font-size: 12px;
        color: ${({ theme }) => rgba(theme.black, 0.6)};
        font-weight: 400;
    }
`;
